export const faqPlatformRelated = [
  {
    id: "faq_1",
    question: "What types of artists can I book through this platform?",
    answer: (
      <div>
        We offer a wide range of talented artists including magicians,
        musicians, singers, comedians, dancers, and more. Whatever your event
        may be, we have the perfect performer for you!
        <br />
      </div>
    ),
  },
  {
    id: "faq_2",
    question: "How do I book an artist for my event?",
    answer: (
      <div>
        Simply browse through our artist profiles, check their availability, and
        submit a booking request with your event details. Our team will confirm
        the booking and handle all arrangements.
        <br />
      </div>
    ),
  },
  {
    id: "faq_3",
    question: "How do I pay for my booking?",
    answer: (
      <div>
        Once your booking is confirmed, you’ll receive an invoice. Payments can
        typically be made via credit card, bank transfer, or other online
        payment methods.
        <br />
      </div>
    ),
  },
  {
    id: "faq_4",
    question: "Can I request a specific artist?",
    answer:
      "Yes! You can browse through the artist profiles and choose the one you want for your event. If they’re available, we’ll confirm the booking.",
  },
];

export const faqBookingRelated = [
  {
    id: "faq_1",
    question: "What information do I need to provide when booking an artist?",
    answer:
      "To make your booking smooth and seamless, please provide: Event date, time, and location. Type of performance you’re looking for, Event duration and any special requests,Your contact details",
  },
  {
    id: "faq_2",
    question: `Do the artists travel to my location?`,
    answer:
      "Yes, many of our artists are available to travel to your location. Travel fees may apply depending on the distance and the artist’s availability.",
  },
  {
    id: "faq_3",
    question: "How far in advance should I book an artist?",
    answer:
      "We recommend booking at least 2-4 weeks in advance, especially for popular dates. However, some artists may be available for last-minute bookings.",
  },
  {
    id: "faq_4",
    question: "Can I change or cancel my booking?",
    answer:
      "Yes, you can request to modify or cancel your booking, but please refer to our cancellation policy for details on fees or refunds. Cancellation requests made 7 days or more before the event are generally eligible for a full refund.",
  },
  {
    id: "faq_5",
    question: "What happens if the artist I booked becomes unavailable?",
    answer:
      "If an artist is unable to perform due to unforeseen circumstances, we’ll work with you to find a suitable replacement. If no suitable replacement is available, you’ll be refunded in full.",
  },
];

export const faqOthers = [
  {
    id: "faq_1",
    question: "Can I provide my own equipment for the performance?",
    answer: `In most cases, artists bring their own equipment, but we’re happy to accommodate specific requests if you prefer to provide your own gear. Just let us know in advance.`,
  },
  {
    id: "faq_2",
    question: "Is there a minimum performance time required?",
    answer:
      "Minimum performance time requirements vary by artist. Typically, performances range from 30 minutes to 2 hours. Please refer to the individual artist’s profile for details.",
  },
  {
    id: "faq_3",
    question: "What if I have a specific theme or request for the performance?",
    answer:
      "Feel free to communicate your event theme or specific requests when booking. Many of our artists are open to customizing their performances to fit your needs.",
  },
  {
    id: "faq_4",
    question: "What should I do if I have more questions or need assistance?",
    answer:
      "If you have any other questions or need help with your booking, please don’t hesitate to contact our customer support team via email or phone. We’re here to help!",
  },
];
